export default {
  city: "City",
  addCity: "AddCity",
  editCity: "EditCity",
};
